import AppComponent from '../../mixins/app-component'

import AppIcon from '../app-icon'
import AppInputEmail from '../app-input-email'

export default
{
    name: 'app-popin-email',

    mixins: [
        AppComponent
    ],

    components: {
        AppIcon,
        AppInputEmail
    },

    data() {
        return {
            isOpen: false
        }
    },

    created() {
        this.eventHub.$on('app-popin-email:show-popin', this._showPopin)
    },

    mounted() {
        document.addEventListener('keydown', this._onKeydown)
    },

    destroyed() {
        this.eventHub.$off('app-popin-email:show-popin', this._showPopin)

        document.removeEventListener('keydown', this._onKeydown)
    },

    methods: {
        _onKeydown(event) {
            if (event.keyCode === 27) {
                this._hidePopin()
            }
        },

        _hidePopin() {
            this.isOpen = false
        },

        _showPopin() {
            this.isOpen = true
        }
    }
}



// WEBPACK FOOTER //
// ./src/scripts/components/app-popin-email/script.js